module.exports = __webpack_public_path__ + "static/media/mouthDimpleLeft.d4cf913d.obj";